module.exports = __webpack_public_path__ + "47996620776b753b5655633e5afd0c65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/public/img/washs/wash-5.jpg
// module id = 79
// module chunks = 0